import { StyleSheet } from "@react-pdf/renderer";
import { Table, TD, TH, TR } from '@ag-media/react-pdf-table';
import PDFHtmlRenderer from "./PDFHtmlRenderer";
import { isHTMLContentEmpty } from "helpers/common";

const styles = StyleSheet.create({
  colHead: {
      backgroundColor: "#f0f0f0",
      border: "1px solid #B9B9B9",
      fontSize: '8px',
      fontWeight: 800,
      padding: "8px",
      fontWeight: 'bold'
  },
  col: {
      border: "1px solid #B9B9B9",
      fontWeight: 500,
      padding: "8px",
      fontSize: 8,
      fontWeight: 'light',
  }
})

const AssessmentTableDataPDF = ({ chartData = [] }) => {
  if (!chartData || chartData.length === 0) return null;

  const maxCols = Math.max(...chartData.map((row) => row.length));

  return (
    <Table style={{ borderRadius: '4px', width: "100%" }}>
      {/* Header */}
      <TH>
        {Array.from({ length: maxCols }).map((_, colIndex) => (
          <TD key={colIndex} style={[styles.colHead]}>
            <PDFHtmlRenderer
              data={chartData[0]?.[colIndex] || ""}
              style={{
                fontSize: 8,
                fontWeight: 'bold'
              }}
            />
          </TD>
        ))}
      </TH>

      {/* Rows */}
      {chartData.slice(1).map((row, rowIndex) => (
        !isHTMLContentEmpty(row[0]) ? (
          <TR key={rowIndex}>
            {Array.from({ length: maxCols }).map((_, colIndex) => (
              <TD key={colIndex} style={[styles.col, { backgroundColor: colIndex > 0 ? "#fff" : "#f0f0f0" }]}>
                  <PDFHtmlRenderer
                    data={row[colIndex] || ""}
                    style={{
                      fontSize: 8,
                      fontWeight: 'light'
                    }}
                  />
              </TD>
            ))}
          </TR>
        ):(
          null
        )
      ))}
    </Table>
  );
};

export default AssessmentTableDataPDF;